const getFormErrors = async ($validator, formErrors) => {
  const errors = await $validator.errors.items;

  errors.forEach((error) => {
    formErrors[error.field] = [error.msg];
  });
  return formErrors;
};

export default getFormErrors;
